import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection, Position } from '@iotv/iotv-v3-types';

const typeName = 'SoilMsmtPt';

export type SoilMsmtPtProps = {
  purpose?: string;
  sensorModel?: number;
  moistureLevel?: number;
  state?: string;
  location?: Position;
  image?: string;
};

export class SoilMsmtPt extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  purpose?: string;
  sensorModel?: number;
  moistureLevel?: number;
  state?: string;
  location?: Position;
  image?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name of Soil Measurement point' },
      purpose: { type: 'String', editable: true, label: 'Purpose', name: 'purpose', description: 'Measurement purpose' },
      sensorModel: { type: 'Number', editable: true, label: 'Sensor model', name: 'sensorModel', description: 'Model of soil moisture and Sensor details' },
      moistureLevel: { type: 'Number', editable: true, label: 'Moisture Level', name: 'moistureLevel', description: 'Moisture in some unit' },
      state: { type: 'String', editable: true, label: 'State', name: 'state', description: 'State of mechanism - operational, requires maintenance etc' },
      location: { type: 'object', editable: true, label: 'Location', name: 'location', description: 'Location of  point (lat/ long)' },
      image: { type: 'String', editable: true, label: 'Image', name: 'image', description: 'Photograph of Soil Moisture Device in situ' },
      comments: { type: 'String', editable: true, label: 'Comments', name: 'comments', description: 'Free text for info ' },
    };
  };
}
